(ns practitest.frontend.components2.traceability
  (:require [ajax.core :as ajax]
            [clojure.string :as str]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.common.local-storage :as ls]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.grid.events :as grid.events]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.events :as events]
            [practitest.frontend.milestone.subs :as milestone.subs]
            [practitest.frontend.common.re-frame :refer [partial-dispatch]]
            [practitest.frontend.milestone.events :as milestone.events]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common.tooltip :as common-tooltip]
            [practitest.frontend.components2.pagination :as pagination]
            [practitest.frontend.components.users :as users]
            [practitest.frontend.components2.grid :as grid2]
            [practitest.frontend.components2.run-status :as run-status]
            [practitest.frontend.components2.issue-status :as issue-status]
            [practitest.frontend.components2.requirement-testing-status :as requirement-testing-status]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.common.i18n :refer [format-translation get-translation] :as i18n]
            [practitest.frontend.common.permissions :as permissions]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.forms3.entity-form.utils :refer [track! get-modal-title]]
            [practitest.frontend.forms3.entity-form.traceability :refer [traceability-tab]]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.common-entities :refer [batch-navigate!]]
            [practitest.frontend.components2.add-entities :as add-entities]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

(re-frame/reg-event-fx
  ::delete-traceability
  (fn [{db :db} [_ entity-type entity-id traceability-entity]]
    {:db (update db :progress conj [::delete-traceability (:id traceability-entity)])
     :http-xhrio
     {:method          :post
      :uri             (broutes/get-url "issues#delete_traceability" {:p_id (subs/get-current-project-id db)
                                                                      :id entity-id})
      :params          {:traceability_entity_type (:type traceability-entity)
                        :traceability_entity_id (:id traceability-entity)}
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::delete-traceability-success entity-type entity-id traceability-entity]
      :on-failure      [::delete-traceability-failure traceability-entity]}}))

(re-frame/reg-event-db
  ::delete-traceability-success
  (fn [db [_ entity-type entity-id traceability-entity response]]
    (track! "Delete Entity from traceability" entity-type)

    (-> db
        (update :progress disj [::delete-traceability (:id traceability-entity)])
        (assoc-in [:entity entity-type :traceability] (:traceability response)))))

(re-frame/reg-event-fx
  ::delete-traceability-failure
  (fn [{db :db} [_ traceability-entity error]]
    {:db (-> db
             (update :progress disj [::delete-traceability (:id traceability-entity)]))
     :dispatch [::notifications/error2 (if-let [message (:message (:response error))]
                                         message
                                         (get-translation "traceability.delete-error"
                                                          "Error deleting traceability item"))]}))

(defn grid-options [{:keys [state-key
                            table-id-suffix
                            current-entity]}]
  (let [str-entity (name current-entity)]
    {:table-id              (str (:id @(re-frame/subscribe [::subs/current-project]))
                                 "-"  str-entity"-" table-id-suffix)
     :dialog-table-id       (str (:id @(re-frame/subscribe [::subs/current-project]))
                                 "-" str-entity "-link-" table-id-suffix)
     :grid-class            "data-grid-milestone-entities"

     :data                  (re-frame/subscribe [::grid.subs/data [current-entity state-key]])
     :columns               (re-frame/subscribe [::grid.subs/columns [current-entity state-key]])
     :selected-entities     (re-frame/subscribe [::grid.subs/selection [current-entity state-key]])
     :selected?             #(re-frame/subscribe [::grid.subs/selected? [current-entity state-key] %])
     :all-selected?         #(re-frame/subscribe [::grid.subs/all-selected? [current-entity state-key] %])
     :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [current-entity state-key]])
     :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [current-entity state-key]])
     :current-page          (re-frame/subscribe [::grid.subs/entities-current-page current-entity state-key])
     :total-count           (re-frame/subscribe [::grid.subs/entities-total-count current-entity state-key])
     :full-data?            (re-frame/subscribe [::grid.subs/entities-full-data? current-entity state-key])}))

(defn link-entities-dialog-options [{:keys [state-key query-event link-event default-filter-name current-entity]}]
  {:show? (re-frame/subscribe [::grid.subs/show-link-entities-modal? current-entity state-key])
   :hide! #(re-frame/dispatch [::milestone.events/hide-link-entities-modal state-key])
   :show-views? (re-frame/subscribe [::grid.subs/link-entities-show-views? current-entity state-key])
   :filters (re-frame/subscribe [::grid.subs/link-entities-filters current-entity state-key default-filter-name])
   :current-filter-selected (re-frame/subscribe [::grid.subs/link-entities-current-filter-selected current-entity state-key])
   :set-current-filter (partial-dispatch [::milestone.events/set-link-entities-dialog-grid-filter state-key query-event])
   :set-current-folder (partial-dispatch [::common-events/set-current-folder :testset state-key
                                          ::common-events/fetch-entity-list-by-folder])
   :on-query-changed (partial-dispatch [query-event])
   :on-add-entities (partial-dispatch [link-event])
   ;; TODO: this should be part of the `grid-options` function
   ;;       but right now it looks like loading indicator is not shown anymore, so it doesn't matter until we fix it
   :loading? (re-frame/subscribe [::subs/progress? query-event])})

(defn traceability-card
  [{:keys [on-delete]
    :as   props} & children]
  (let [card-state (reagent/atom {})
        card-ref (atom nil)]
    (fn [{:keys [on-delete]
          :as   props} & children]
      (let [hover? (:hover? @card-state)]
        (into [:div.traceability-card
               {:ref            #(reset! card-ref %)
                :on-mouse-over  (fn [e]
                                  (swap! card-state assoc :hover? true))
                :on-mouse-leave (fn [e]
                                  (swap! card-state assoc :hover? false))
                :class          (dom/classes-pairs-v
                                  :hover hover?)}

               (when on-delete
                 [:div.card-delete-button
                  {:on-click (fn [e]
                               (on-delete))}
                  [icons/mux-trash]])]
              children)))))

(defn field-labeled
  [all-fields field-id default-label value]
  ;; Label can be customized even for system fields, so we're looking it in the DB
  (let [label (or (:label (get all-fields field-id))
                  default-label)]
    [:span (str label ": " value)]))

(defn traceability-card-run
  [{:keys [entity-type
           entity-id]
    :as form-props} steprun]
  (let [run (:run steprun)
        instance (:instance run)
        testset (:testset instance)
        test (:test run)
        users @(re-frame/subscribe [::subs/users])
        has-edit-permissions (permissions/has-permission? "runs")
        retest-uri (broutes/get-url-view "qtest_runs#retest_run"
                                         {:id (:id run)
                                          :p-id (:project_id run)})]
    [traceability-card
     {:on-delete (fn [e]
                   (re-frame/dispatch [::delete-traceability entity-type entity-id steprun]))}
     ;; Run
     [:div.traceability-card-row.first-row
      [:span.entity-type-icon
       [icons/mux-run]]
      [:span.entity-type-text
       "Run"]
      [:a {:target "blank" :href (if (= (:type run) "etrun")
                                   (broutes/get-url-view "et#edit" {:id (:id run)
                                                                    :s_id (:id testset)})
                                   (broutes/get-url-view "qtest_runs#edit" {:id (:id run)}))}
       (fu/formatted-date-time (:run_date run))]
      [:div.retest-container
        [icons/mux-retest-icon]
        [:button.retest-btn
          {:class (str "retest-btn" (when (not has-edit-permissions) " disabled"))
           :disabled (not has-edit-permissions)
           :on-click (fn [e]
                      (when-not (.-disabled (.-currentTarget e))
                        (set! (.-disabled (.-currentTarget e)) true)
                        (mixpanel/track "Retest from issue" {"Run ID" (:id run) "Issue ID" entity-id})
                        (let [retest-uri (broutes/get-url-view "qtest_runs#retest_run" {:id (:id run)})
                              params  [(:id run)
                                        (:id test)
                                        (:id testset)
                                        entity-id]]
                          (batch-navigate! retest-uri params))))}
      "Retest"]
      [common-tooltip/info-circle-tooltip
        (get-translation "issue.tooltip.retest"
          "This action will create a new run based on the previous one. If there have been significant changes made to the test since that run, please initiate the new run directly from the updated test.")]]

      [:span.status-holder
       [run-status/run-status-component (:status run)]]]

     [:div.traceability-card-row.second-row
      [:span.name-with-link
       (str "Test #" (:display_id test) ": ")
       [:a {:href (broutes/get-url-view "tests#edit" {:id (:id test)})} (:name test)]]

      [:span.name-with-link
       (str "Test set #" (:display_id testset) ": ")
       [:a {:href (broutes/get-url-view "suites#edit" {:id (:id testset)})} (:name testset)]]

      (let [user (users/find-user users (:tester_id run))]
       [:div.traceability-card-row.last-row
        [:span "Tester:"] [users/user-avatar2 user]
        ;; Prefer embedded name so removed-from-project users still render.
        (or (:tester_user_name run) (:name user))])]]))

(defn traceability-card-issue
  [{:keys [entity-type
           entity-id
           all-fields]
    :as form-props} issue]
  [traceability-card
   {:on-delete (fn [e]
                 (re-frame/dispatch [::delete-traceability entity-type entity-id issue]))}
   ;; Issue
   [:div.traceability-card-row.first-row
    [:span.entity-type-icon
     [icons/mux-issue]]
    [:span.entity-type-text
     "Issue #" (:display_id issue) ":"]
    [:span.name-with-link
     [:a {:target "blank" :href (broutes/get-url-view "issues#edit" {:id (:id issue)})}
      (:name issue)]]
    [:span.status-holder
     [issue-status/issue-status-component (:status issue)]]]

   [:div.traceability-card-row.second-row
    [field-labeled all-fields :updated_at "Last modified" (fu/formatted-date-time (:updated_at issue))]]])

(defn traceability-card-requirement
  [{:keys [entity-type
           entity-id
           all-fields]
    :as form-props} requirement]
  [traceability-card
   {:on-delete (fn [e]
                 (re-frame/dispatch [::delete-traceability entity-type entity-id requirement]))}
   [:div.traceability-card-row.first-row
    [:span.entity-type-icon
     [icons/mux-requirement]]
    [:span.entity-type-text
     "Requirement #" (:display_id requirement) ":"]
    [:span.name-with-link
     [:a {:target "blank" :href (broutes/get-url-view "requirements#edit" {:id (:id requirement)})}
      (:name requirement)]]
    [:span.status-holder
     [requirement-testing-status/requirement-status-component (:status requirement)]]]

   [:div.traceability-card-row.second-row
    [field-labeled all-fields :updated_at "Last modified" (fu/formatted-date-time (:updated_at requirement))]]])

(defn traceability-card-milestone
  [{:keys [entity-type
           entity-id
           all-fields]
    :as form-props} milestone]

  [traceability-card
   {:on-delete (fn [e]
                 (re-frame/dispatch [::delete-traceability entity-type entity-id milestone]))}
   [:div.traceability-card-row.first-row
    [:span.entity-type-icon
     [icons/mux-milestone]]
    [:span.entity-type-text
     "Milestone #" (:display_id milestone) ":"]
    [:span.name-with-link
     [:a {:target "blank" :href (router/get-href :practitest.frontend.milestones/edit {:milestone-id (:id milestone)
                                                                       :project-id   (:project_id milestone)})}
      (:name milestone)]]
    [:span.status-holder
     (:milestone_status milestone)]]

   [:div.traceability-card-row.second-row
    [field-labeled all-fields :milestone_start_date "Start date"
     (fu/formatted-local-date (:milestone_start_date milestone))]
    [field-labeled all-fields :milestone_end_date "End date"
     (fu/formatted-local-date (:milestone_end_date milestone))]]
   [:div.traceability-card-row.last-row
    [field-labeled all-fields :milestone_type "Type" (:milestone_type milestone)]]])

(defn get-section-title
  [type count]
  ;; TODO: plural ?
  (case type
    :runs
    (str "Linked runs (" count ")")

    :issues
    (str "Linked issues (" count ")")

    :requirements
    (str "Linked requirements (" count ")")

    :milestones
    (str "Linked milestones (" count ")")

    ;else
    (str "Invalid type: " type)))

(defn get-section-view
  [type form-props item]
    (case type
      :runs
      [traceability-card-run form-props item]

      :issues
      [traceability-card-issue form-props item]

      :requirements
      [traceability-card-requirement form-props item]

      :milestones
      [traceability-card-milestone form-props item]

      ;else
      [:pre "Invalid type: " (str type)]))

(defn entities-dialog [{:keys [link-entities-props] :as form-props}]
  (let [container-ref (atom nil)]
    (fn [_]
      [:div.milestone-grid-container
       {:ref #(reset! container-ref %)}
       [add-entities/add-entities-dialog
        container-ref
        (merge link-entities-props
               (select-keys form-props [:get-field-props])
               {:table-id (:dialog-table-id form-props)})]])))

(defn traceability-section
  [form-props type traceability-data]
  (let [state (-> (reagent/atom {:collapsed?   false
                                 :current-page 1})
                  (ls/wrap-atom-with-session-storage
                    (str "pt-frontend."
                         (name (:form-id form-props))
                         "."
                         (str (:entity-id form-props))
                         ".traceability."
                         (name type))))]
    (fn [form-props type traceability-data]
      (let [collapsed? (:collapsed? @state)
            have-items? (boolean (seq traceability-data))
            per-page 6
            total-count (count traceability-data)
            pagination? (> total-count per-page)
            current-page (or (:current-page @state) 1)
            total-pages (pagination/get-total-pages total-count per-page)
            ;; reset current page if it's outside current range (can happen due to deletion of items on last page)
            current-page (if (> current-page total-pages)
                           total-pages
                           current-page)
            page-cards (pagination/get-current-page-items traceability-data current-page per-page)]
        [:div.traceability-section
         [:div.traceability-section-header
          ;; Collapse/expand
          [:div.traceability-collapse-control
           {:on-click (fn [e]
                        (swap! state update :collapsed? not))
            :class    (dom/classes-pairs-v
                        :clickable have-items?)}
           (when have-items?
             [:span
              (if collapsed?
                [icons/mux-chevron-right]
                [icons/mux-chevron-up2])])
           [:span
            (get-section-title type total-count)]]

          [:div.header-controls
           (when (and pagination?
                      (not collapsed?))
             [:div.traceability-pagination
              [pagination/pagination-view
               {:current-page current-page
                :total-count  total-count
                :per-page     per-page
                :max-buttons  8
                :on-change    (fn [page]
                                (swap! state assoc :current-page page))}]
              [:div.vertical-separator]
              [pagination/pagination-info-span total-count current-page per-page]
              [:div.vertical-separator]])

           (when (and (contains? #{:issues :requirements :milestones} type)
                      (not collapsed?)
                      (:edit-permissions? form-props))
             [:div
              [buttons/button
               {:toolbar? true
                :on-click (fn [_]
                            (track! "Add Entity to traceability" (:entity-type form-props))
                            ((:toggle-link-entities-modal! form-props)))
                :icon [icons/mux-plus-circle]
                :text "Add"}]
              [entities-dialog form-props type]])]]

         (when (and have-items?
                    (not collapsed?))
           [:div.traceability-section-cards
            (doall
              (for [item page-cards]
                (with-meta (get-section-view type form-props item)
                           {:key (:id item)})))])]))))

(re-frame/reg-sub
  ::traceability
  (fn [db]
    (get-in db [:entity (:current-entity db) :traceability])))

(defn traceability-table-id
  [entity-name]
  (let [entity-str (name entity-name)
        project-id (:id @(re-frame/subscribe [::subs/current-project]))]
      (str project-id "-" entity-str "-link-issues-grid")))

(defn issue-traceability-page
  [form-props]
  (let [traceability @(re-frame/subscribe [::traceability])]
    (when (some? traceability)
      [:div.traceability-body
       [traceability-section form-props :runs
        ;; Concat ets and usual tests here
        (apply conj
               (:runs traceability)
               (:ets traceability))]

       (let [table-id (traceability-table-id :issue)
             disabled-row? (fn [row]
                             (let [linked-issues (:issues @(re-frame/subscribe [::traceability]))
                                   linked-ids (set (map #(:id %) linked-issues))]
                               (contains? linked-ids (:id row))))
             link-entities-props
             (merge (grid-options {:state-key       :link-issues-state
                                   :table-id-suffix "link-issues-grid"
                                   :current-entity :issue})
                    (link-entities-dialog-options {:state-key :link-issues-state
                                                   :query-event ::milestone.events/fetch-issues
                                                   :link-event ::milestone.events/link-issues
                                                   ;; TODO: localization for default filter name?
                                                   :default-filter-name "All Issues"
                                                   :current-entity :issue})
                    {
                     :module "Issue"
                     :title  (get-modal-title
                               (get-translation "issue.issues.link-dialog.title" "Add Issues")
                               (get-translation "to.milestone" "to Milestone")
                               (:display_id form-props)
                               (:name form-props))
                     :disabled-row? disabled-row?
                     :disabled-row-tooltip (fn [_row]
                                             (format-translation
                                              (get-translation "milestone.requirements.disabled-row.tooltip"
                                                               "%{linked} already linked to this %{entity}")
                                              {:linked "Issue"
                                               :entity "issue"}))
                     :disabled-select-all? #(some disabled-row? %)
                     :disabled-select-all-tooltip (format-translation
                                                   (get-translation "milestone.requirements.disabled-select-all.tooltip"
                                                                    "Cannot select all %{linked} because some of the %{linked} already linked to this %{entity}")
                                                   {:linked "issues"
                                                    :entity "issue"})
                     :add-entities-button-label (get-translation "milestone.requirements.link-button"
                                                                 "Add selected %{n} Issues")})]
         [traceability-section (merge form-props
                                      {:dialog-table-id             table-id
                                       :on-query-changed            (partial-dispatch [::milestone.events/fetch-linked-requirements])
                                       :empty-table-message         (get-translation "milestone.requirements.add-requirements-to-your-milestone"
                                                                                     "Add requirements to your milestone")
                                       :delete-label                (get-translation "generic.button.remove"
                                                                                     "Remove")
                                       :on-unlink                   #(re-frame/dispatch [::milestone.events/unlink-requirements %])
                                       :link-label                  (get-translation "milestone.requirements.link"
                                                                                     "Link Issue")
                                       :toggle-link-entities-modal! (fn [_e]
                                                                      ;; TODO: event parameter
                                                                      (re-frame/dispatch [::common-events/toggle-link-entities-modal
                                                                                          :issue
                                                                                          :link-issues-state
                                                                                          ::milestone.events/fetch-issues
                                                                                          nil])
                                                                      (mixpanel/track "Milestone - Link Requirement"))
                                       :link-entities-props         link-entities-props})
          :issues
          (:issues traceability)])

       (let [table-id (traceability-table-id :requirement)
             disabled-row? (fn [row]
                             (let [linked-requirements (:requirements @(re-frame/subscribe [::traceability]))
                                   linked-ids (set (map #(:id %) linked-requirements))]
                               (contains? linked-ids (:id row))))
             link-entities-props
             (merge (grid-options {:state-key       :link-requirements-state
                                   :table-id-suffix "link-requirements-grid"
                                   :current-entity :issue})
                    (link-entities-dialog-options {:state-key :link-requirements-state
                                                   :query-event ::milestone.events/fetch-requirements
                                                   :link-event ::milestone.events/link-requirements
                                                   ;; TODO: localization for default filter name?
                                                   :default-filter-name "All Requirements"
                                                   :current-entity :issue })
                    {
                     :module "Requirement"
                     :title  (get-modal-title
                                (get-translation "issue.requirements.link-dialog.title" "Add Requirements")
                                (get-translation "to.milestone" "to Milestone")
                                (:display_id form-props)
                                (:name form-props))
                     :disabled-row? disabled-row?
                     :disabled-row-tooltip (fn [_row]
                                             (format-translation
                                              (get-translation "milestone.requirements.disabled-row.tooltip"
                                                               "%{linked} already linked to this %{entity}")
                                              {:linked "Requirement"
                                               :entity "issue"}))
                     :disabled-select-all? #(some disabled-row? %)
                     :disabled-select-all-tooltip (format-translation
                                                   (get-translation "milestone.requirements.disabled-select-all.tooltip"
                                                                    "Cannot select all %{linked} because some of the %{linked} already linked to this %{entity}")
                                                   {:linked "Requirement"
                                                    :entity "issue"})
                     :add-entities-button-label (get-translation "milestone.requirements.link-button"
                                                                 "Add selected %{n} Requirements")})]
         [traceability-section (merge form-props
                                      {:dialog-table-id             table-id
                                       :title                       (get-modal-title
                                                                      (get-translation "milestone.requirements.link" "Link Requirements")
                                                                      (get-translation "to.milestone" "to Milestone")
                                                                      (:display_id form-props)
                                                                      (:name form-props))
                                       :on-query-changed            (partial-dispatch [::milestone.events/fetch-linked-requirements])
                                       :empty-table-message         (get-translation "milestone.requirements.add-requirements-to-your-milestone"
                                                                                     "Add requirements to your milestone")
                                       :delete-label                (get-translation "generic.button.remove"
                                                                                     "Remove")
                                       :on-unlink                   #(re-frame/dispatch [::milestone.events/unlink-requirements %])
                                       :link-label                  (get-translation "milestone.requirements.link"
                                                                                     "Link Requirement")
                                       :toggle-link-entities-modal! (fn [_e]
                                                                      ;; TODO: event parameter
                                                                      (re-frame/dispatch [::common-events/toggle-link-entities-modal
                                                                                          :requirement
                                                                                          :link-requirements-state
                                                                                          ::milestone.events/fetch-requirements
                                                                                          nil])
                                                                      (mixpanel/track "Issue - Link Requirement"))
                                       :link-entities-props         link-entities-props})
          :requirements
          (:requirements traceability)])
       ])))

(def traceability-keys
  [:runs :ets :instances :tests :testsets :issues :requirements
   :called_by_ctts :ancestor_info :requirement_children])

(defn traceability-total-count
  [traceability]
  (->> traceability-keys
       (map #(count (get traceability %)))
       (reduce + 0)))

(defn build-traceability-tab
  []
  (let [traceability @(re-frame/subscribe [::traceability])
        total-count (traceability-total-count traceability)]
    {:tab-id   :traceability
     :tab-title
     [:span.text-nowrap
      (format-translation
        (get-translation "entity.tab.traceability" "Traceability (%{n})")
        :n total-count)]
     :tab-view traceability-tab}))
